import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';

export interface DialogData {
  title: string;
  options: Map<any, any>;
}

@Component({
  selector: 'app-options-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatListModule, MatButtonModule, MatRadioModule, FormsModule],
  templateUrl: './options-dialog.component.html',
  styleUrl: './options-dialog.component.css'
})
export class OptionsDialogComponent {
  selectedOption: string | null = null;

  constructor(public dialogRef: MatDialogRef<OptionsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  confirm(): void {
    this.dialogRef.close(this.selectedOption);
  }

  cancel(): void {
    this.dialogRef.close();
  }

}